'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Spicy;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Spicy(props) {
    var height = props.height,
        secondaryColor = props.secondaryColor,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    var style = {
        height: height,
        padding: '0px ' + height / 1.75 + 'px',
        fontSize: height / 1.9 + 'px',
        lineHeight: height + 'px',
        backgroundColor: primaryColor,
        color: secondaryColor,
        letterSpacing: height / 12.5 + 'px'
    };

    return _react2.default.createElement(
        'div',
        { role: 'img', 'aria-labelledby': 'imgSpicy', id: 'imgSpicy', className: 'restaurants-menus-icons-label', style: style, 'data-hook': 'wixrest-menus-icon-label-spicy' },
        i18n.get('openrest_menubuilderv3_dishlabels_spicy') || 'spicy'
    );
}

Spicy.displayName = 'Spicy';
Spicy.propTypes = {
    height: _propTypes2.default.number,
    secondaryColor: _propTypes2.default.string,
    primaryColor: _propTypes2.default.string
};
Spicy.defaultProps = {
    height: 21,
    secondaryColor: '#fff',
    primaryColor: '#c4270e'
};